import { render, staticRenderFns } from "./GraphDetail56.vue?vue&type=template&id=2683718e&scoped=true"
import script from "./GraphDetail56.vue?vue&type=script&lang=js"
export * from "./GraphDetail56.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683718e",
  null
  
)

export default component.exports